// extracted by mini-css-extract-plugin
export default {"FilterBloc":"StartupsFilter_FilterBloc__fPfSA","DrawerFooter":"StartupsFilter_DrawerFooter__T5Yo9"};